// import { setSocketFailed, setSocketPending } from './actions';
import { checkUsersSession } from '../../services/checkUsersSession';
import { setSocketStatusFailed, setSocketStatusPending } from '../../slices/socketStatusSlice';
import { ERequestApiStatus } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';
import { ETelemetryEvents } from '../../types/telemetry';
import { isSomeOfAPIErrors } from '../../utils/network_errors';
import { retryWithDelay } from '../../utils/retryWithDelay';
import { registerWsSession, registerWsSessionFailed } from '../wsSession';

const RETRIES_COUNT = 4;

/**
 * Открытие канала WS
 */
export const openEventChannel =
  (): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, telemetry, custom: { socket } }) => {
    if (!socket) {
      return;
    }

    const { eventChannel } = socket;

    const { session } = getState();

    dispatch(setSocketStatusPending());

    // Если соединение не закрыто
    // TODO: избавиться от блока
    if (eventChannel.hasInstance() && !eventChannel.isChannelClosed()) {
      await dispatch(registerWsSession());

      // Если истекла сессия (стоит пересмотреть логику)
      if (session.status !== ERequestApiStatus.Succeed && session.status !== ERequestApiStatus.Pending) {
        await dispatch(checkUsersSession());
      }

      return;
    }

    // Если истекла сессия (стоит пересмотреть логику)
    if (session.status !== ERequestApiStatus.Succeed && session.status !== ERequestApiStatus.Pending) {
      await dispatch(checkUsersSession());
    }

    try {
      // Делаем 4 попытки открыть соединение с задержкой в 1, 2, 3, 4 секунды
      await retryWithDelay(
        () => {
          if (eventChannel.isChannelClosed()) {
            return eventChannel.connectToEventChannel() as Promise<void>;
          }

          return Promise.resolve();
        },
        error => {
          if (isSomeOfAPIErrors(error)) {
            // TODO: ws errors code https://tools.ietf.org/html/rfc6455#section-7.4.1
          }

          logger.error(error, {
            domain: 'src/shared/actions/socket/openEventChannel.ts',
            message: 'Event Channel retry connection error: ',
          });
        },
        RETRIES_COUNT,
      );
    } catch (e) {
      dispatch(setSocketStatusFailed());
      dispatch(registerWsSessionFailed());
      telemetry.increment(ETelemetryEvents.ChatWsSessionFail);

      return;
    }

    return dispatch(registerWsSession());
  };
